






























































import { Component, Prop } from "vue-property-decorator";

import ProgressBar from "@share/common/progress/ProgressBar.vue";
import TooltipIcon from "@share/common/TooltipIcon.vue";
import SingleSelect from "@share/common/form/form-controls/select/variations/single-select/SingleSelect.vue";
import JConfTableS01 from "@share/common/tables/j-conf-table/simple/JConfTable-S01.vue";
import TableLimitMessage from "@share/participants-import/components/table-limit-message/TableLimitMessage.vue";
import UserBlock from "@share/common/user/UserBlock.vue";
import ImportStep from "../ImportStep.vue";

import { DuplicateAction, Progress, ProgressState } from "@share/participants-import/types";
import { HeaderSetting, TableSettings } from "@share/common/tables/j-conf-table/types";
import { ProfileField } from "../../../../../types/ProfileField";
import { UserProfile } from "@api/models/UserProfile";
import { DropDownItem } from "@share/common/drop-down/types";
import { EventMembershipTypes } from "@api/enums/EventMembershipTypes";
import { getProgressCount } from "@share/participants-import/helpers/progress";
import { getHeaderSettingsByFields } from "@share/participants-import/helpers/headerSettings";

@Component({ components: { ProgressBar, JConfTableS01, TooltipIcon, UserBlock, SingleSelect, TableLimitMessage } })

export default class Step3Import extends ImportStep {
    @Prop({ required: true }) progress: Progress;
    @Prop({ required: true }) rows: UserProfile[];
    @Prop({ required: false }) fileLink: string;
    @Prop({ required: true }) limit: number;

    EventMembershipTypes = EventMembershipTypes;
    ProgressState = ProgressState;

    tableSettings: TableSettings = {
        minRowHeight: 76
    }

    get defaultAction(): DropDownItem {
        return {
            title: this.$t("participants.import.duplicateAction." + DuplicateAction.dontAdd).toString(),
            id: DuplicateAction.dontAdd
        }
    }

    additionalFields = ['lastName', 'firstName', 'phoneNumber', 'email'];

    actionSearch(): DropDownItem {
        throw Error('method not implemented')
    }

    get actionTypes(): DropDownItem[] {
        return [
            this.defaultAction,
            {
                title: this.$t("participants.import.duplicateAction." + DuplicateAction.update).toString(),
                id: DuplicateAction.update
            },
            {
                title: this.$t("participants.import.duplicateAction." + DuplicateAction.add).toString(),
                id: DuplicateAction.add,
                extraField1: this.$t("participants.import.duplicateAction.addTooltip").toString()
            }
        ]
    }

    get headerSettings(): HeaderSetting[] {
        const language = this.$store.state.session?.language ?? 'en';

        let fields: ProfileField[] = [{
            title: {
                en: "#",
                ru: "№",
                uk: "№"
            },
            name: "__rowNum__",
            type: "input",
        }];

        const profileParams = this.$store.getters['events/selectedEventViewParam']('profile', null);

        if (profileParams?.fields) {

            const profileFields = this.additionalFields
                .map((fieldName) => {
                    return profileParams.fields.find((field: ProfileField) => field.name === fieldName)
                })
                .filter((field: ProfileField) => field)

            fields = [...fields, ...profileFields];
        }

        fields.push({
            title: {
                en: "Existing user",
                ru: "Существующий пользователь",
                uk: "Існуючий користувач"
            },
            name: "existingUser",
            type: "input",
        })

        fields.push({
            title: {
                en: "Choice of action",
                ru: "Выбор действия",
                uk: "Вибір дії"
            },
            name: "choiseOfAction",
            type: "input",
        })

        return getHeaderSettingsByFields(fields, language);
    }

    //move to common function
    getCaption(field: ProfileField, language: string) {
        return field && field.title && field.title[language]
            ? field.title[language]
            : this.$t('settings.' + field.name.toLowerCase()).toString();
    }

    getSide(index: number) {
        return index > 1 ? 'top' : 'bottom'
    }

    get rowsForRender() {
        return this.rows.slice(0, this.limit);
    }

    get foundWord() {
        return this.$t("participants.found").toString().split(",")[1]?.toLowerCase();
    }

    get progressCount(): number {
        return getProgressCount(this.progress);
    }

    get onProgress() {
        return this.progress.state !== ProgressState.idle
    }

    get progressEmpty() {
        return this.progress.state === ProgressState.empty
    }
}

